import { render, staticRenderFns } from "./BarProgress.vue?vue&type=template&id=3e52b451&scoped=true&"
import script from "./BarProgress.vue?vue&type=script&lang=js&"
export * from "./BarProgress.vue?vue&type=script&lang=js&"
import style0 from "./BarProgress.vue?vue&type=style&index=0&id=3e52b451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52b451",
  null
  
)

export default component.exports